import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.function.name";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapMutations } from 'vuex';
import AsideComponent from '@/view/layout/aside/asideComponent';
import MenuItem from './asideComponent/menuItem';
export default {
  name: 'Aside',
  components: {
    AsideComponent: AsideComponent,
    MenuItem: MenuItem
  },
  data: function data() {
    return {
      active: '',
      isCollapse: false,
      menuActive1: '',
      menuActive2: '',
      subMenuData2: {
        children: [],
        title: '',
        defaultOpeneds: []
      }
    };
  },
  computed: _objectSpread({}, mapGetters('router', ['asyncRouters'])),
  watch: {
    $route: function $route() {
      this.setActive();
    }
  },
  created: function created() {
    var _this = this;

    this.setActive();
    var screenWidth = document.body.clientWidth;

    if (screenWidth < 1000) {
      this.isCollapse = !this.isCollapse;
    }

    this.$bus.on('collapse', function (item) {
      _this.isCollapse = item;
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.off('collapse');
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('history', ['addHistory'])), {}, {
    findParentRoute: function findParentRoute(name, routers) {
      var _this2 = this;

      console.log('findParentRoute - ' + name, routers);
      var routeItem = null;

      if (routers && routers.length) {
        routers.some(function (item) {
          if (item.name === name) {
            routeItem = item;
            return true;
          }

          if (item.children && item.children.length) {
            var temp = _this2.findParentRoute(name, item.children);

            if (temp !== null) {
              routeItem = item;
              return true;
            }
          }

          return false;
        });
      }

      return routeItem;
    },
    setActive: function setActive() {
      var parentRouteItem = this.findParentRoute(this.$route.name, this.asyncRouters[0].children);
      this.active = this.$route.name;
      this.menuActive2 = this.$route.name;
      this.menuActive1 = parentRouteItem.name;
      this.subMenuData2.children = parentRouteItem.children;
      this.subMenuData2.title = parentRouteItem.meta.title;
      this.subMenuData2.defaultOpeneds = parentRouteItem.children ? parentRouteItem.children.map(function (item) {
        return item.name;
      }) : [];
    },
    selectMenuItem1: function selectMenuItem1(index) {
      var subMenuData2 = this.asyncRouters[0].children.filter(function (item) {
        return item.name === index;
      });

      if (subMenuData2 && subMenuData2.length) {
        this.subMenuData2.children = subMenuData2[0].children;
        this.subMenuData2.title = subMenuData2[0].meta.title;
        this.subMenuData2.defaultOpeneds = subMenuData2[0].children ? subMenuData2[0].children.map(function (item) {
          return item.name;
        }) : [];
      }
    },
    selectMenuItem2: function selectMenuItem2(index, _, ele) {
      var query = {};
      var params = {};
      console.log('index', index);
      console.log('ele', ele);
      ele.route.parameters && ele.route.parameters.map(function (item) {
        if (item.type === 'query') {
          query[item.key] = item.value;
        } else {
          params[item.key] = item.value;
        }
      });
      if (index === this.$route.name) return;

      if (index.indexOf('http://') > -1 || index.indexOf('https://') > -1) {
        console.log('window.open(index)');
        window.open(index);
      } else {
        console.log('this.$router.push', {
          name: index,
          query: query,
          params: params
        });
        this.$router.push({
          name: index,
          query: query,
          params: params
        });
        console.log('this.$router', this.$router);
      }
    }
  })
};